import { RadioProps, RadioGroupProps } from "react-aria-components";
import { ReactNode } from "react";

export enum MDSRadioSlotName {
  Before = "before",
  After = "after",
}

export interface MDSRadioProps extends RadioProps {
  /**
   * Children to render as the radio label.
   */
  children?: ReactNode;
}

export interface MDSRadioGroupProps extends Omit<RadioGroupProps, "children"> {
  /**
   * The label for the radio group.
   */
  label?: string;

  /**
   * The description for the radio group.
   */
  description?: string;

  /**
   * The error message for the radio group.
   */
  errorMessage?: string;

  /**
   * Children to render within the radio group.
   */
  children?: ReactNode;
}
